/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Automatic_Offset_TitleInputs */

const en_editor_automatic_offset_title = /** @type {(inputs: Editor_Automatic_Offset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic Offset`)
};

const fr_editor_automatic_offset_title = /** @type {(inputs: Editor_Automatic_Offset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decalage automatique`)
};

const de_editor_automatic_offset_title = /** @type {(inputs: Editor_Automatic_Offset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatischer Offset`)
};

const it_editor_automatic_offset_title = /** @type {(inputs: Editor_Automatic_Offset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offset automatico`)
};

const ru_editor_automatic_offset_title = /** @type {(inputs: Editor_Automatic_Offset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическое смещение`)
};

const es_editor_automatic_offset_title = /** @type {(inputs: Editor_Automatic_Offset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplazamiento automático`)
};

const zh_cn2_editor_automatic_offset_title = /** @type {(inputs: Editor_Automatic_Offset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动偏移`)
};

const ja_editor_automatic_offset_title = /** @type {(inputs: Editor_Automatic_Offset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動オフセット`)
};

const hi_editor_automatic_offset_title = /** @type {(inputs: Editor_Automatic_Offset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित ऑफसेट`)
};

const pt_pt2_editor_automatic_offset_title = /** @type {(inputs: Editor_Automatic_Offset_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deslocamento automático`)
};

/**
* | output |
* | --- |
* | "Automatic Offset" |
*
* @param {Editor_Automatic_Offset_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_automatic_offset_title = /** @type {((inputs?: Editor_Automatic_Offset_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Automatic_Offset_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_automatic_offset_title(inputs)
	if (locale === "de") return de_editor_automatic_offset_title(inputs)
	if (locale === "it") return it_editor_automatic_offset_title(inputs)
	if (locale === "ru") return ru_editor_automatic_offset_title(inputs)
	if (locale === "es") return es_editor_automatic_offset_title(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_automatic_offset_title(inputs)
	if (locale === "ja") return ja_editor_automatic_offset_title(inputs)
	if (locale === "hi") return hi_editor_automatic_offset_title(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_automatic_offset_title(inputs)
	return en_editor_automatic_offset_title(inputs)
});